import type { DocumentData } from "firebase/firestore";
import BaseApi from "../../core/BaseApi";
import BusinessInfoModuleModel from "./BusinessInfoModule/BusinessInfoModel";
import type BusinessModuleModel from "./BusinessModuleModel";
import type { BusinessModuleModelData, Snapshot } from "./BusinessModuleModel";
import BusinessReminderModuleModel from "./BusinessReminder/BusinessReminderModuleModel";
import { BusinessModuleType } from "./types";

type Data = BusinessModuleModel<Snapshot, BusinessModuleModelData<Snapshot>>;

export default class BusinessModulesApi extends BaseApi<
  Data,
  BusinessModuleModelData
> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}business_modules`;
  }

  get store() {
    return this.stores.businessModulesStore;
  }

  fromFirestore(res: DocumentData): Data {
    const data = res.data();

    if (data.type === BusinessModuleType.Reminder) {
      return new BusinessReminderModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    if (data.type === BusinessModuleType.Info) {
      return new BusinessInfoModuleModel(this.stores, this.api, {
        uid: res.id,
        ...data,
      });
    }

    throw Error(
      `Tried to create invalid business module with type ${data.type}`,
    );
  }
}
